export const BUILD_VERSION = '1789989046100';
